<ng-container *ngIf="Busy">
    <p>Please wait while we check for additional required acknowledgements...</p>
</ng-container>

<div class="package-terms" *ngFor="let ack of RequiredAcknowledgements">
    {{ack.Name}}

    <ng-container *ngIf="ack.Key == '3F30F2EB-F240-44C0-8137-54A08D3E511A'">
        <ng-container *ngTemplateOutlet="NYBPP; context: {$implicit:ack}"></ng-container>
    </ng-container>
    <button class="btn btn-primary" (click)="Acknowledge(ack.Key)">I Agree</button>
</div>

<ng-template #NYBPP let-ack>
    <hr />

    <h1>New York Notice: Excess Lines Placement</h1>
    <h2>Business Articles Coverage</h2>
    <h3>Notice of excess line placement</h3>

    <p>Date: {{ack.Data.dateRequested | date:'shortDate' }}</p>

    <p>Consistent with the requirements of the New York Insurance Law and Regulation 41:<br />
        <span class="u">{{ack.Data.cst_ind_full_name_dn}}</span> is hereby advised that all or a
        portion of the required
        coverages have been placed by Michael J. Schroeder with insurers not authorized to do an insurance business in
        New
        York and which are not subject to supervision by this State. Placements with unauthorized insurers can only be
        made
        under one of the following circumstances:
    </p>
    <ul>
        <li>A diligent effort was first made to place the required insurance with companies authorized in New York to
            write
            coverages of the kind requested; or</li>
        <li>NO diligent effort was required because i) the coverage qualifies as an "Export List" risk, or ii) the
            insured
            qualifies as an "Exempt Commercial Purchaser."</li>
    </ul>
    <p>Policies issued by such unauthorized insurers may not be subject to all of the regulations of the Superintendent
        of
        Financial Services pertaining to policy forms. In the event of insolvency of the unauthorized insurers, losses
        will
        not be covered by any New York State security fund.</p>

    <h3>Total cost form (non tax allocated premium transaction)</h3>
    <p>In consideration of your placing my insurance as described in the policy referenced below, I agree to pay the
        total
        cost below which includes all premiums, inspection charges<sup>(1)</sup> and a service fee that includes taxes,
        stamping fees, and (if indicated) a fee<sup>(1)</sup> for compensation in addition to commissions received, and
        other expenses<sup>(1)</sup></p>
    <p>I further understand and agree that all fees, inspection charges and other expenses denoted by (1) are, fully
        earned
        from the inception date of the policy and are non-refundable regardless of whether said policy is cancelled. Any
        policy changes which generate additional premium are subject to additional tax and stamping fee charges.</p>

    <table class="border nybpp">
        <tr>
            <td colspan="2" class="border-bottom">
                <span>Policy Number: {{ack.Data.policy_number}}</span>
                <span class="float-right">Name of Insurer: Certain Underwriters at Lloyd's of London</span>
            </td>
        </tr>
        <tr>
            <td class="border-right">Policy Premium</td>
            <td>{{(ack.Data.policy_cost == 99 ? 54 : 180) | currency}}</td>
        </tr>
        <tr>
            <td class="u border-right">Insurer Imposed Charges:</td>
            <td>&nbsp;</td>
        </tr>
        <tr>
            <td class="indent border-right">Policy Fees<sup>(1)</sup></td>
            <td>{{ 0 | currency }}</td>
        </tr>
        <tr>
            <td class="indent border-right">Inspection Fees<sup>(1)</sup></td>
            <td class="bottomline">{{ 0 | currency }}</td>
        </tr>
        <tr>
            <td class="border-right">Total Taxable Charges</td>
            <td class="border-top">{{(ack.Data.policy_cost == 99 ? 54 : 180) | currency}}</td>
        </tr>
        <tr>
            <td class="border-right">Service Fee Charges</td>
            <td>&nbsp;</td>
        </tr>
        <tr>
            <td class="border-right">Excess Lines Tax (3.60%)</td>
            <td>{{(ack.Data.policy_cost == 99 ? 1.94 : 6.48) | currency}}</td>
        </tr>
        <tr>
            <td class="border-right">Stamping Fee (0.150%)</td>
            <td>{{(ack.Data.policy_cost == 99 ? .08 : .27) | currency}}</td>
        </tr>
        <tr>
            <td class="border-right">Broker Fee<sup>(1)</sup></td>
            <td>{{0 | currency}}</td>
        </tr>
        <tr>
            <td class="border-right">Inspection Fee<sup>(1)</sup></td>
            <td>{{0 | currency}}</td>
        </tr>
        <tr>
            <td class="border-right">Other Expenses (specify)<sup>(1)</sup>: <span class="u">Membership Fee</span></td>
            <td>{{(ack.Data.policy_cost == 99 ? 42.98 : 112.25) | currency}}</td>
        </tr>
        <tr>
            <td class="border-right">Total Policy Cost</td>
            <td class="border-top">{{ack.Data.policy_cost | currency}}</td>
        </tr>
    </table>

    <p>Signature of Insured: <span class="u">{{ack.Data.cst_ind_full_name_dn}}</span> (As per online agreement, online
        consent and transaction.)</p>
    <p>(1) = Fully Earned</p>
    <p>
        <span>NYSID Form: NELP/2011</span>
        <span class="float-right">G5501</span>
    </p>
</ng-template>